
import React, { useState, useRef, useEffect } from "react";
import styles from "./Navbar.module.css";
import { useNavigate, useLocation } from "react-router-dom";
import navbarData from "../../../json/navbarData.json";
import categoryContent from "../../../json/categoryContent.json";

const { navLinks, megaContent } = navbarData;
const megaKeys = Object.keys(megaContent);

const getCategorySlug = (path) => {
  if (!path) return "";
  const match = path.match(/category=([^&]+)/);
  return match ? match[1] : "";
};

const isItemDisabled = (item) => {
  const slug = getCategorySlug(item.path);
  // Direct pages (no category param, e.g. /IFU) are always enabled
  if (!slug) return false;
  return !categoryContent[slug]?.items?.length;
};

const Navbar = ({ compact = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const tabsRef = useRef({});
  const [notchTop, setNotchTop] = useState(0);
  const [showMenu, setShowMenu] = useState(false);
  const [activeTab, setActiveTab] = useState(megaKeys[0]);
  const [mobileNewsOpen, setMobileNewsOpen] = useState(false);
  const [mobileActiveTab, setMobileActiveTab] = useState(megaKeys[0]);
  const [showMegaMenu, setShowMegaMenu] = useState(false);
  const [mobileTooltip, setMobileTooltip] = useState(null);

  const showMobileTooltip = (id) => {
    setMobileTooltip(id);
    setTimeout(() => {
      setMobileTooltip((curr) => (curr === id ? null : curr));
    }, 2000);
  };

  const toggleMenu = () => {
    setShowMenu(!showMenu);

    if (!showMenu) {
      setMobileActiveTab(megaKeys[0]);
    }
  };
  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    if (tabsRef.current[activeTab]) {
      const el = tabsRef.current[activeTab];
      setNotchTop(el.offsetTop + el.offsetHeight / 2 - 12);
    }
  }, [activeTab]);

  const notchPositions = {
    news: "5%",
    science: "36%",
    corporate: "53%",
    regulatory: "20%",
  };

  const renderLabel = (text, wrapperClass = "") => {
    const parts = text.split(/(&|-)/g);
    // split karega & aur - dono ko alag tokens me

    return (
      <span className={wrapperClass}>
        {parts.map((part, index) => {
          if (part === "&") {
            return (
              <span key={index} className={styles.deffrentFamily}>
                &
              </span>
            );
          }

          if (part === "-") {
            return (
              <span key={index} className={styles.hyphenFamily}>
                -
              </span>
            );
          }

          return <React.Fragment key={index}>{part}</React.Fragment>;
        })}
      </span>
    );
  };
  return (
    <div className={`${styles.navbarContainer} ${compact ? styles.compact : ""}`}>
      <nav className={styles.navbar}>
        <div className={styles.logo} onClick={() => navigate("/")}>
          <img
            src="/Images/newLogo.png"
            alt="Bruno Vision Care logo"
            width="132"
            height="162"
          />
        </div>

        <div className={styles.navLinks}>
          {navLinks.slice(0, 4).map((link) => (
            <span
              key={link.id}
              className={`${styles.navLink} ${isActive(link.path) ? styles.activeNav : ""}`}
              onClick={() => navigate(link.path)}
            >
              {link.label}
            </span>
          ))}

          <div
            className={styles.megaWrapper }
            onMouseEnter={() => setShowMegaMenu(true)}   style={{display:"none"}}
          >
            <span
              className={`${styles.navLink} ${styles.newsroomLink} ${isActive("") ? styles.activeNav : ""
                }`}
              onClick={() => navigate("")}
            >
              Newsroom <span><img src="/svg/drop_down_arrow.svg" alt="drop_down_arrow" /></span>
            </span>

   

            {showMegaMenu && (
              <div className={styles.megaMenu}>
                <div className={styles.megaInner}>
                  {/* LEFT SIDE */}
                  <div className={styles.megaLeft}>
                    {megaKeys.map((key) => (
                      <div
                        key={key}
                        ref={(el) => (tabsRef.current[key] = el)}
                        className={`${styles.megaTab} ${activeTab === key ? styles.activeTab : ""}`}
                        onClick={() => setActiveTab(key)}
                      >
                        {renderLabel(megaContent[key].label)}
                        <span>→</span>
                      </div>
                    ))}

                    <button
                      className={styles.MedtechBtn}
                      onClick={() => {
                        navigate("/deseyne-medtech-breakthrough-award-2026");
                        setShowMegaMenu(false);
                      }}
                    >
                      2026 MEDTECH  AWARD
                    </button>
                    <button
                      className={styles.exploreEventBtn}
                      onClick={() => {
                        navigate("/academy-2026-anaheim");
                        setShowMegaMenu(false);
                      }}
                    >
                      Meet Bruno at AAO 
                    </button>
                  </div>

       
                  <div
                    key={activeTab}
                    className={styles.megaRight}
                    style={{ "--notch-top": notchPositions[activeTab] }}
                  >
             
                    <div className={styles.innerMegaRight}>
                      {megaContent[activeTab].items.map((item, index) => {
                        const sectionBlur = false;
                        const itemBlur = !sectionBlur && isItemDisabled(item);
                        const notAllowed = sectionBlur || itemBlur;
                        return (
                          <div
                            className={`${styles.subartical} ${
                              sectionBlur ? styles.subarticalBlur : ""
                            } ${itemBlur ? styles.itemDisabled : ""}`}
                            key={index}
                            style={{ cursor: notAllowed ? "not-allowed" : "pointer" }}
                            onClick={() => {
                              if (notAllowed) return;
                              navigate(item.path);
                              setShowMegaMenu(false);
                            }}
                          >
                            <p className={styles.itemTitle}>
                              {renderLabel(item.title)}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                    <button
                      className={`${styles.megaBtn} ${(activeTab === "science" || activeTab === "corporate")
                        ? styles.megaBtnBlur
                        : ""
                        }`}
                      onClick={() => {
                        navigate(megaContent[activeTab].path);
                        setShowMegaMenu(false);
                      }}
                    >
                      {megaContent[activeTab].buttonText} <span className={styles.fontArrow}>→</span>
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          {navLinks.slice(4).map((link) => (
            <span
              key={link.id}
              className={`${styles.navLink} ${isActive(link.path) ? styles.activeNav : ""}`}
              onClick={() => navigate(link.path)}
            >
              {link.label}
            </span>
          ))}
        </div>

        <div className={styles.hamburger} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </nav>


      <div className={`${styles.offcanvas} ${showMenu ? styles.open : ""}`}>
        <div className={styles.offcanvasClose} onClick={toggleMenu}>
          &times;
        </div>

        {navLinks.slice(0, 4).map((link) => (
          <span
            key={link.id}
            className={`${styles.navLink} ${isActive(link.path) ? styles.activeNav : ""}`}
            onClick={() => navigate(link.path)}
          >
            {link.label}
          </span>
        ))}

      
        
        <div className={styles.mobileNewsWrapper}  style={{display:"none"}}>
          <span
            className={styles.navLink}
            onClick={() => setMobileNewsOpen(!mobileNewsOpen)}
          >
            Newsroom{" "}
            {mobileNewsOpen ? (
              <img src="/svg/iconup-Arrow.svg" alt="drop-Arrow" />
            ) : (
              <img src="/svg/icondrop-Arrow.svg" alt="iconup-Arrow" />
            )}
          </span>

          {mobileNewsOpen && (
            <div className={styles.mobileDropdown}>
              {megaKeys.map((key) => (
                <div key={key}>
                  <div
                    className={`${styles.mobileTab} ${mobileActiveTab === key ? styles.mobileTabActive : ""
                      }`}
                    onClick={() =>
                      setMobileActiveTab(mobileActiveTab === key ? null : key)
                    }
                  >
                    {renderLabel(megaContent[key].label)}
                    <img src="/svg/icondrop-Arrow.svg" alt="drop-icon" className={`${styles.mobileArrow} ${mobileActiveTab === key ? styles.rotate : ""
                      }`} />
                  </div>

                  {mobileActiveTab === key && (
                    <div className={styles.mobileSubContentMAin}>
                  
                      <div className={styles.mobileSubContent}>
                        {megaContent[key].items.map((item, index) => {
                          const sectionBlur = false;
                          const itemBlur = !sectionBlur && isItemDisabled(item);
                          const notAllowed = sectionBlur || itemBlur;
                          const tooltipId = `${key}-${index}`;
                          return (
                            <div
                              key={index}
                              className={`${styles.mobileSubItem} ${
                                sectionBlur ? styles.subarticalBlur : ""
                              } ${itemBlur ? styles.itemDisabled : ""}`}
                              style={{
                                cursor: notAllowed ? "not-allowed" : "pointer",
                              }}
                              onClick={() => {
                                if (notAllowed) {
                                  showMobileTooltip(tooltipId);
                                  return;
                                }
                                navigate(item.path);
                                setShowMenu(false);
                                setMobileNewsOpen(false);
                                setMobileActiveTab(null);
                              }}
                            >
                              <p>{renderLabel(item.title)}</p>
                              {notAllowed && mobileTooltip === tooltipId && (
                                <span className={styles.mobileTooltip}>
                                  No content available
                                </span>
                              )}
                            </div>
                          );
                        })}

                      </div>

                   
                      <button
                        className={`${styles.megaBtn} ${(mobileActiveTab === "science" || mobileActiveTab === "corporate")
                          ? styles.megaBtnBlur
                          : ""
                          }`}
                        onClick={() => {
                          if (
                            mobileActiveTab === "science" ||
                            mobileActiveTab === "corporate"
                          ) {
                            showMobileTooltip(`${key}-viewall`);
                            return;
                          }
                          navigate(megaContent[key].path);
                          setShowMenu(false);
                          setMobileNewsOpen(false);
                          setMobileActiveTab(null);
                        }}
                      >
                        {megaContent[key].buttonText}
                        <span className={styles.fontArrow}> → </span>
                        {mobileTooltip === `${key}-viewall` && (
                          <span className={styles.mobileTooltip}>
                            No content available
                          </span>
                        )}
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        {navLinks.slice(4).map((link) => (
          <span
            key={link.id}
            className={`${styles.navLink} ${isActive(link.path) ? styles.activeNav : ""}`}
            onClick={() => navigate(link.path)}
          >
            {link.label}
          </span>
        ))}
        <button
          className={styles.MedtechBtn}
          onClick={() => {
            navigate("/deseyne-medtech-breakthrough-award-2026");
            setShowMenu(false);
          }}
        >
          2026 MEDTECH  AWARD
        </button>
        {/* <button
          className={styles.exploreEventBtn}
          onClick={() => {
            navigate("/academy-2026-anaheim");
            setShowMenu(false);
          }}
        >
          Meet Bruno at AAO 
        </button> */}
        
      </div>
    </div>
  );
};

export default Navbar;
